import { RuleContainerSetting, RuleHelper } from '@absg/nim-client-shared';
import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: '[nc-boolean-rule]',
  templateUrl: './boolean-rule.component.html',
  standalone: false,
})

export class BooleanRuleComponent {
  @Input() rule: RuleContainerSetting;
  @Input() rulesFormGroup: UntypedFormGroup;
  @Input() isEditAuthorized: boolean;
  @Input() controlName: string;
  @Input() controlSliderWrapperName: string;
  @Input() set disableRule(value: boolean) {
    const ctrl = this.rulesFormGroup.controls[this.controlName];
    if (value) {
      ctrl.disable();
    } else {
      ctrl.enable();
    }
  }
  @Input() set isChecked(value: boolean) {
    const ctrl = this.rulesFormGroup.controls[this.controlName];
    ctrl.setValue(value);
  }
  get isChecked(): boolean {
    return this.rulesFormGroup.controls[this.controlName].value;
  }

  clickBooleanValue(event: Event, rule: RuleContainerSetting): void {
    if (this.isEditAuthorized) {
      this.changeBooleanValue(rule);
    } else {
      event.preventDefault();
    }
  }

  changeBooleanValue(rule: RuleContainerSetting): void {
    rule.booleanValue = this.rulesFormGroup.controls[this.controlName].value;
    rule.value = this.getValueFromBooleanValue(rule.booleanValue);
  }

  getValueFromBooleanValue(booleanValue: boolean): string {
    return RuleHelper.getBooleanToString(booleanValue);
  }
}
